
export default function useHasCompanionMode() {
    return RivalIQ.state.account.get('hasCompanionMode');
}
